import { render, staticRenderFns } from "./addDepartmentModal.vue?vue&type=template&id=041fca58&scoped=true"
import script from "./addDepartmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./addDepartmentModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./addDepartmentModal.vue?vue&type=style&index=0&id=041fca58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fca58",
  null
  
)

export default component.exports